import * as React from "react"
import PropTypes from "prop-types"
import Navbar from "../global/Navbar/navbar"
import Footer from "../global/Footer/footer"

const Layout = ({ children }) => {
  return (
    <>
      <div className="container-fluid p-0 min-vh-100 d-flex flex-column 
                justify-content-between">
        <Navbar />
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
